<template>
  <div id="page-home" class="home" style="background-color: #f3f4f6">
    <div class="notify" v-show="userInfo">
      <van-icon name="chat-o" :badge="unReadMsgNum" size="25" color="#ffffff"
        @click="$router.push({ name: 'notify-list' })" />
    </div>
    <!-- 轮播图 -->
    <van-swipe class="home-swipe" :autoplay="10000" v-if="has_banner">
      <van-swipe-item v-for="(item, index) in banners.thumb" :key="index">
        <van-image class="banner-image" @click="pointClick(item)" :src="item.url" fit="fill" />
      </van-swipe-item>
    </van-swipe>
    <!-- 公告 -->
    <div class="notify-container" v-if="notifies.length > 0">
      <img class="notify-img" @click="handleNotifyClick" src="../../assets/img/home/noti.png" />
      <van-swipe class="notify-swipe" :show-indicators="false" :autoplay="3000" vertical v-if="notifies.length > 0">
        <van-swipe-item v-for="(item, index) in notifies" :key="index">
          <span @click="handleNotifyItemClick(item)" class="notify-title">{{
            item.title
          }}</span>
        </van-swipe-item>
      </van-swipe>
    </div>
    <template v-if="this.userInfo.custType > 0">
      <!-- 体验金产品 -->
      <div v-if="experienceId" style="margin: 10px 15px 0 15px" @click="
        $router.push({ path: '/detail', query: { productId: experienceId } })
        ">
        <img style="
            width: 100%;
            height: 100%;
            object-fit: fill;
            border-radius: 10px;
          " src="../../assets/img/experience/experience_bg.png" fit="fill" />
      </div>
      <template v-if="auctionList.length > 0">
        <!-- 拍品推荐 -->
        <div class="recommended">
          <div>
            <span>拍品推荐</span>
          </div>
          <!-- 查看更多拍品 -->
          <div class="seeMore" @click="investClick(1)">
            <span>更多</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <!-- 拍品列表 -->
        <home-auction-item v-for="(n, i) of auctionList" :key="`auction-${i}`" :item="n" />
      </template>

      <template v-if="productList.length > 0">
        <!-- 产品推荐 -->
        <div class="recommended">
          <div>
            <span>产品推荐</span>
          </div>
          <!-- 查看更多产品 -->
          <div class="seeMore" @click="investClick(1)">
            <span>更多</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <!-- 产品列表 -->
        <home-product-item v-for="(n, i) of productList" :key="`product-${i}`" :item="n" />
      </template>

      <!-- 体验金 -->
      <div v-if="promProduct" class="common" @click="goPromDetail(promProduct)">
        <div class="product-information" :class="{
          'sold-out':
            promProduct.isFull ||
            promProduct.serverTime >= promProduct.endTime
        }">
          <div class="title">
            <span>{{ promProduct.name }}</span>
            <van-tag class="points" v-if="promProduct.scoreRate > 0">返积分</van-tag>
          </div>
          <div class="tag">
            <van-tag class="tag1" v-if="item.label1" :class="{
              hide: !promProduct.label1 || promProduct.label1.length < 1
            }" plain color="#ff9900">{{ promProduct.label1 }}</van-tag>
            <van-tag class="tag2" v-if="item.label2" :class="{
              hide: !promProduct.label1 || promProduct.label1.length < 1
            }" plain color="#ff9900">{{ promProduct.label2 }}</van-tag>
            <van-tag v-if="item.attachLabel" plain color="#ff9900">{{
              item.attachLabel
            }}</van-tag>
          </div>

          <div class="data">
            <div class="gain">
              <b>{{ promProduct.expectedRate }}</b>
              <span>%</span>
              <div class="txt">预期年化收益率</div>
            </div>

            <div class="term">
              <div class="term-box">
                <!-- day -->
                <div class="day">
                  <span class="s1">{{ promProduct.investDuration }}</span>
                  <span class="s2">天</span>
                </div>
                <!-- text -->
                <div class="txt">
                  <!-- {{ promProduct.miniAmount / 1000000 }}万元起投 -->
                </div>
              </div>
            </div>
          </div>
          <!-- progress -->
          <div class="progress">
            <div class="progress-box">
              <!-- progress-style -->
              <div class="progress-style">
                <div v-if="isSoldOut(promProduct)" class="progress-pivot" style="width: 100%"></div>
                <div v-else class="progress-pivot" :style="{ width: promProduct.sold + '%' }"></div>
              </div>
              <!-- result -->
              <div class="result">{{ progressText(promProduct) }}</div>
            </div>
          </div>
        </div>
        <div class="aside" color="#fc6524" size="large">
          <span>新手专享</span>
        </div>
      </div>

      <template v-if="this.token && this.userInfo.custType > 0">
        <!-- 图片 -->
        <div class="recommended">
          <span>安全保障</span>
          <!-- <span @click="goLicence">更多</span> -->
        </div>
        <div class="img">
          <img src="../../assets/img/home/img_01.png" alt />
          <img src="../../assets/img/home/img_02.png" alt />
          <img src="../../assets/img/home/img_03.png" alt />
          <img src="../../assets/img/home/img_04.png" alt />
        </div>
      </template>

      <!-- 注册赢好礼, 享投资专属服务 s-->
      <van-row class="home-notlogin" type="flex" v-if="!logined">
        <van-col span="24">
          <div class="home-notlogin-txt">3秒注册赢好礼, 享投资专属服务</div>
          <van-button class="home-notlogin-btn" type="danger" @click="goLogin" round>注册／登录</van-button>
        </van-col>
      </van-row>
      <div v-if="!logined" class="home-bg-line"></div>

      <!-- 非金融 s-->
      <div class="jrong mt-30" v-if="
        channel &&
        ['bl', 'zn', 'tajk'].includes(channel.toLowerCase()) &&
        goods &&
        goods.length > 0
      ">
        <div class="points-to-benefits">
          <div class="box">
            <div class="left">
              <div class="sp1">积分兑福利</div>
              <div class="sp2">投资聚财宝 天天聚财</div>
            </div>
            <div class="sp3" @click="moreClick">更多</div>
          </div>
        </div>
        <div class="jrong-box">
          <div class="jrong-list flex-row flex-j-sb flex-wrap product-list">
            <router-link v-for="(n, i) in goods" class="jrong-list-item product mb-20"
              :to="{ name: 'shop-product', params: { id: n.id } }" :key="`goods-${i}`">
              <img :src="n.coverImg" />
              <div class="text fy">
                <b>{{ n.title }}</b>
              </div>
              <div class="price color-gray-dark fs-12 fy" style="text-decoration: line-through">
                市场价：{{ n.oldPriceStr }}元
              </div>
              <div class="ta-c">
                <van-button class="mt-5 bg-color-orange-shop fy" block size="small" type="warning">{{ n.scoreStr
                }}积分</van-button>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <!-- 非金融 e-->
      <div class="home-footer" style="
          display: flex;
          flex-direction: column;
          align-items: center;
          color: rgb(174, 174, 177);
          font-size: 16px;
          padding-top: 20px;
        ">
        <!-- <van-image class="home-footer-logo" :src="footer_logo"></van-image> -->
        <div @click="onCallServiceMobile">
          <span>天安金交中心客服电话：</span>
          <span style="font-weight: 900">40069-40070</span>
        </div>
        <div>或在“天安金交中心”微信公众号留言</div>
        <!-- <div></div> -->
        <van-button @click="onService" class="home-footer-service" v-show="false" plain type="danger" round
          size="small">咨询客服</van-button>
      </div>
    </template>
    <template v-else>
      <div class="service-bg" v-if="token">
        <div class="recommended">
          <span>服务流程</span>
        </div>
        <div class="item-bg">
          <div :class="['item', 'col' + index]" v-for="(item, index) in serviceInfo.minList" :key="index"
            @click="onServiceMinItem(item)">
            <img :src="item.icon" />
            <div class="item-btn">{{ item.title }}</div>
          </div>
        </div>
        <div class="max-item-bg">
          <div :class="['max-item', 'max-col' + index]" v-for="(item, index) in serviceInfo.maxList" :key="index"
            @click="onServiceMaxItem(item)">
            <div class="title-txt">{{ item.title }}</div>
            <div class="content-txt">{{ item.content }}</div>
          </div>
        </div>
      </div>
      <div class="service-bottom-bg">
        <div class="service-section-bg" v-for="(item, index) in serviceInfo.sectionList" :key="index">
          <div class="recommended">
            <span>{{ item.name }}</span>
          </div>
          <div class="section-item-bg" v-for="(childrenItem, c_index) in item.children" :key="c_index"
            @click="onNoWhiteListItem(childrenItem)">
            <img class="left-img" :src="childrenItem.picturePath" />
            <div class="right-bg">
              <div class="r-l-bg">
                <div class="r-title">{{ childrenItem.name }}</div>
                <div class="r-content">{{ childrenItem.content }}</div>
              </div>
              <van-icon name="arrow" color="rgb(226, 226, 226)" size="20"></van-icon>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- 隐私政策 s-->
    <van-dialog class="dialog-privacy" v-model="dialogPrivacyShow" title="隐私政策" confirm-button-text="同意"
      @confirm="onConfirm" show-cancel-button style="z-index: 99999">
      <div class="px-20 fs-14">
        <p>
          天安金交中心重视用户的隐私,您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本《隐私政策》向您说明，在使用我们的服务时，我们如何收集、使用、储存和分享这些信息，以及我们为您提供的访问、更新、控制和保护这些信息的方式。本《隐私政策》与您所使用的其明服务息息相关，希望您仔细阅读，在需要时，按照本《隐私政策》的指引，作出您认为适当的选择。本《隐私政策》中涉及的相关技术词汇，我们尽量以简明扼要的表述，并提供进一步说明的链接，以便您的理解。
        </p>
        <p>
          请阅读完整的
          <router-link :to="{ name: 'agreement-userPrivacy' }" style="color: #df4845">《隐私政策》</router-link>
          <router-link :to="{ name: 'agreement-reg' }"
            style="color: #df4845">《注册协议》</router-link>，了解我们为保护您的信息做出的具体措施和承诺。
        </p>
      </div>
    </van-dialog>

    <!-- 隐私政策 e-->
    <van-popup class="assess-dialog" v-model="assessShow">
      <h2 class="mt-0 fs-xxl ta-c">您还没有完成风险测评</h2>
      <div class="mb-20">
        根据相关法规，买入前先进行测评，以便了解自身的风险承受能力，做出理性投资决策
      </div>
      <div class="ta-c">
        <van-button class="btn-assess" plain @click="goAssess">立即测评</van-button>
      </div>
    </van-popup>
    <!-- 风险测评是否强制显示重新测评 -->
    <van-popup class="assess-dialog" v-model="resetAssessShow">
      <h2 class="mt-0 fs-xxl ta-c">温馨提示</h2>
      <div class="mb-20">
        您好！您之前的风险测评已到期，需要重新进行风险测评，请前往测评！
      </div>
      <div class="ta-c">
        <van-button class="btn-assess" plain @click="goAssess">立即测评</van-button>
      </div>
    </van-popup>
    <!-- 最新活动提示框 -->
    <lottery-pop :visible.sync="lotteryShow" :activityType="activityType" :backgroundImg="backgroundImg"
      @onClose="onCloseLottery" @lookRule="clickRule" @enterLottery="enterLottery">
    </lottery-pop>
    <!-- 未填写收货地址弹框 -->
    <!-- isVipActivity  0不弹窗  1弹窗   -->
    <base-one-button-pop :visible.sync="showAddress" title="温馨提示" :content="userInfo.content" btnTitle="去填写地址"
      @onSureClick="onSetingAddress" @onCloseClick="onCloseAddress" />
    <answer-enter-pop :show.sync="showAnswerPop" @close="onCloseAnswerPop" @commitUse="onJoinAnswer" />

    <ratecoupon-pop :visible.sync="showRateCouponPop" :params="rateCouponParams" @close="onCloseRateCouponPop"
      @commitUse="onGetRateCoupon" />

    <new-years-day-pop :yuandanInfo="yuandanInfo" @close="yuandanInfo.showRedpackage = false"
      @commitUse="onImmediateClaim" />

    <van-overlay :show="couponOverlayParams.showCouponPop" @click.stop="couponOverlayParams.showCouponPop = false">
      <div class="new-popup" @click.stop="">
        <div class="popup-main">
          <div class="popup-main-body">
            <div class="fs-28 center-text">
              <span>恭喜获得</span>
            </div>
            <div class="fs-15 sub-text">
              <span>{{ couponOverlayParams.params.name }}</span>
            </div>
            <div class="info-bg">
              <div class="info-left">
                <span class="fs-13" style="vertical-align: sub;">¥</span>
                <span class="fs-36 amount">{{ couponOverlayParams.params.perAmount / 100 || 0 }}</span>
              </div>
              <div class="info-right">
                <div class="fs-15">商品券</div>
                <div class="fs-15">满{{ couponOverlayParams.params.amount / 100 || 0 }}可使用</div>
              </div>
            </div>
          </div>
          <div class="btn-join" @click="clickCommitJoin"></div>
        </div>
      </div>
    </van-overlay>

    <van-popup style="width: 100vw; background-color: transparent" :close-on-click-overlay="false"
      v-model="showSpecialActivity">
      <div class="ta-c mt-15">
        <van-icon style="position: absolute; right: 10%; top: 0" name="close" size="25" color="white"
          @click="onJoinSpecialActivity(false)" />
        <img style="margin-top: 10px; width: 80%; height: auto" src="@/assets/img/lottery/six/sign_toast.png"
          @click="onJoinSpecialActivity(true)" />
      </div>
    </van-popup>
  </div>
</template>

<script>
import * as HomeApi from "@/api/home"
import * as ProductApi from "@/api/product"
import * as GoodsApi from "@/api/goods"
import * as LotteryApi from "@/api/lottery"
import * as MemberIntegralApi from "@/api/memberIntegral"
import { unReadNum } from "@/api/msg"
import storage from "@/utils/storage"
import session from "@/utils/session"
import LotteryPop from "@/components/LotteryPop"
import Popper from "vue-popperjs"
import "vue-popperjs/dist/vue-popper.css"
import {
  Row,
  Col,
  Icon,
  Cell,
  CellGroup,
  Button,
  Swipe,
  SwipeItem,
  Image,
  Toast,
  Dialog,
  Skeleton,
  CountDown,
  Popup,
  Tag,
  Overlay
} from "vant"

import { mapMutations, mapGetters, mapActions } from "vuex"
import { unOperation } from "../../api/market"
import { investMsg, investMsgNoticed } from "../../api/member/events"
import BaseOneButtonPop from "../../components/BaseOneButtonPop.vue"
import { updateVipAddress } from "../../api/cust"
import {
  activityNotice,
  activityRead,
  aprilRedPacket,
  junePreNotice,
  loadAprilOuting,
  mayGrantMayRedPacket,
  midautumnLoad,
  novCheck,
  novReward,
  yuandan26RedList,
  yuandanGrant26,
} from "../../api/lottery"
import HomeAuctionItem from "../../components/HomeAuctionItem.vue"
import HomeProductItem from "@/components/HomeProductItem"
import { preExperienceProduct } from "../../api/product"
import { NOTICES } from "../../utils/storage"
import AnswerEnterPop from "../answerdraw/components/answerEnterPop.vue"
import RatecouponPop from "./components/ratecouponPop.vue"
import NewYearsDayPop from "./components/newYearsDayPop26.vue"

import real_name_img from "../../assets/img/home/whitelist/w_real_name_icon.jpg"
import bind_card_img from "../../assets/img/home/whitelist/w_bind_card_icon.jpg"
import risk_img from "../../assets/img/home/whitelist/w_risk_icon.jpg"
import { getHomeContentList } from "../../api/home"
import { isGetGoodsRedPacket, rewardRedpacket } from "../../api/mall"

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Image.name]: Image,
    [Dialog.Component.name]: Dialog.Component,
    [CountDown.name]: CountDown,
    [Skeleton.name]: Skeleton,
    [Popup.name]: Popup,
    [Tag.name]: Tag,
    [Overlay.name]: Overlay,
    HomeProductItem,
    LotteryPop,
    Popper,
    BaseOneButtonPop,
    HomeAuctionItem,
    AnswerEnterPop,
    RatecouponPop,
    NewYearsDayPop,
  },

  data() {
    return {
      showSpecialActivity: false,
      showAddress: false,
      dialogPrivacyShow: false,
      banners: {
        thumb: []
      },
      logined: true, //  是否已登录, 默认是

      hot_view: "", // 是否已点击过 `新手礼包`
      is_newbie: false, //  是否为新人, 默认否
      newbie: {
        name: "",
        investDuration: "", // 天
        expectedRate: "", //  收益率 1
        greenhandRate: "", // 收益率 2
        id: ""
      },

      has_banner: false, //  是否有banner
      promProduct: false,
      productList: [],
      auctionList: [],

      footer_logo: require("@/assets/img/home/footer-bg.png"),
      goods: [],
      //最大数据量
      maxProductNum: 5,
      assessShow: false,
      resetAssessShow: false,
      imgPath: "",
      lotteryShow: false, //是否有活动弹框
      activityType: 0, //活动类型
      backgroundImg: "", //活动弹框背景图
      isHiddenLottery: false,
      unReadMsgNum: "",
      notifies: [],

      experienceId: "", // 体验金产品ID

      allNoticeList: [],

      showAnswerPop: false,
      answer: false,

      showRateCouponPop: false,
      rateCouponParams: {
        id: "",
        amount: 0.15,
        unit: "%",
        content: "60天及以上资产",
        content1: "可使用",
        isInterest: false // 是否起息
      },

      serviceInfo: {
        minList: [
          {
            title: "去实名",
            icon: real_name_img,
            path: "/realname"
          },
          {
            title: "去绑卡",
            icon: bind_card_img,
            path: "/bindcard"
          },
          {
            title: "去测评",
            icon: risk_img,
            path: "/questions" // questions riskAssessment
          }
          // {
          //   title: "去登录",
          //   icon: login_img,
          //   path: "/login"
          // }
        ],
        maxList: [
          {
            title: "天安金交中心客服电话:",
            content: "40069-40070",
            type: "call"
          },
          { title: "在“天安金交中心”", content: "微信公众号留言", type: "h5" }
        ],
        sectionList: []
      },

      yuandanInfo: {
        showRedpackage: false,
        list: []
      },

      couponOverlayParams: {
        showCouponPop: false,
        params: {
          title: '恭喜获得',
          subtitle: '恭喜您获得',
          amount: 300,
          perAmount: 10,
        }
      }
    }
  },
  watch: {
    userInfo: function (val) {
      if (val.id > 0) {
        this.getNotifyNum()
      }
    }
  },
  beforeMount() {
    if (this.userInfo.isVipActivity == 1) {
      let show = localStorage.getItem("showAddress") || false
      if (!show) {
        this.showAddress = true
      }
    }
    //检测测评
    //forceAssess 是否强制评测
    //assessNum 已评测次数
    this.resetAssessShow =
      this.userInfo.userLevel > 0 ? this.userInfo.forceAssess : false
    if (
      this.os &&
      this.os.toLowerCase() == "android" &&
      storage.get("agree-privacy") !== "1"
    ) {
      this.dialogPrivacyShow = true
    }
    let token = this.$route.query.token || null
    if (token) {
      this.setToken(token)
    } else {
      token = storage.get("app-token")
    }
    if (this.token) this.logined = true
    this.hot_view = storage.get("hot_view")
    let banner = session.getJson("listBanner")
    if (!banner) {
      // 轮播图
      HomeApi.listBanner({ position: 1 })
        .then((data) => {
          if (!data) {
            return
          }
          session.setJson("listBanner", data)
          this.banners.thumb = data
          this.has_banner = true
        })
        .catch((e) => {
          Toast(e.msg || e.message)
        })
    } else {
      this.banners.thumb = banner
      this.has_banner = true
    }

    let notifies = session.getJson("notifies")
    if (!notifies) {
      if (token) {
        // 首页公告轮播
        HomeApi.getHomeNotify({ pageSize: 5, pageNum: 1, noticeType: 1 })
          .then((data) => {
            if (!data) {
              return
            }
            session.setJson("notifies", data)
            this.notifies = data
          })
          .catch((e) => {
            this.$toast(e.msg || e.message)
          })
      }
    } else {
      this.notifies = notifies
    }

    // 热销产品
    let p2 = HomeApi.gethot({
      firstPage: 2,
      pageNo: 1,
      pageSize: 2
    })

    //普通商品
    let p3 = HomeApi.firstPageList({
      firstPage: 1,
      pageNo: 1,
      pageSize: 5
    })
    let promiseList = [p2, p3]

    /**
     * 如果是新手，且是bl渠道，请求体验金资产
     */

    if (
      this.channel &&
      this.channel.toUpperCase() === "BL" &&
      this.userInfo.isNew &&
      this.userInfo.isProm < 2
    ) {
      --this.maxProductNum
      if (this.userInfo.isProm === 0) {
        this.showProm()
      }
      ProductApi.getProm().then((data) => {
        if (data.list.length > 0) {
          this.promProduct = data.list[0]
        }
      })
    }
    /**
     * 如果未登录或新手,请求新手资产
     */
    if (this.userInfo.isNew !== false) {
      // 新手产品
      let p1 = HomeApi.greenhand({
        firstPage: 1,
        pageNo: 1,
        pageSize: 1
      })
      promiseList.unshift(p1)
    }

    Promise.all(promiseList).then((datas) => {
      datas.forEach((n) => {
        if (n.list.length > 0) {
          this.productList.push.apply(this.productList, n.list)
        }
      })
    })
    HomeApi.getHotAuction({
      firstPage: 2,
      pageNo: 1,
      pageSize: 2
    }).then((data) => {
      if (data.list.length > 0) {
        this.auctionList = data.list
      }
    })
    if (
      this.channel &&
      ["bl", "zn", "tajk"].includes(this.channel.toLowerCase())
    ) {
      //非金融
      GoodsApi.list({ pageNo: 1, pageSize: 4 })
        .then((data) => {
          this.goods = data.list
        })
        .catch((e) => {
          Toast(e.msg || e.message)
        })
    }

    this.userInfo && this.getNotifyNum()
  },
  mounted() {
    let agreePrivacy = storage.get("agree-privacy")
    if (this.os.toLowerCase() == "android" && agreePrivacy != 1) {
      this.dialogPrivacyShow = true
    }
    //  let showDialog = localStorage.getItem('loginSuccess')

    if (this.token) {
      let catchList = JSON.parse(localStorage.getItem("HomeNoticeListKey"))
      if (catchList && catchList.length > 0) {
        this.showNoticeInfo(catchList[catchList.length - 1])
      } else {
        this.loadAllNotice()
      }

      this.getPreExperienceProduct()

      this.loadHomeContentList()

      this.loadYuandanRedList()

      this.loadIsGetGoodsRedPacket()
    }
  },
  created() {
    this.isHiddenLottery =
      eval(localStorage.getItem("isHiddenLottery")) || false
    if (!this.token) {
      localStorage.setItem("isHiddenLottery", false)
    }
    if (this.token && !this.isHiddenLottery && this.userInfo.custType > 0) {
      //获取最新活动
      LotteryApi.getLatestActivity()
        .then((data) => {
          localStorage.setItem("isHiddenLottery", true)
          if (!data) {
            return
          }
          localStorage.removeItem("activitys")
          if (data.length > 0) {
            let list = data.filter((item) => item.isShow == 1) // 是否显示活动弹框
            if (list.length > 0) {
              localStorage.setItem("activitys", JSON.stringify(list))
              this.showLottery(list[list.length - 1])
            }
          }
        })
        .catch((e) => {
          if (e.code == 4001 || e.code == 4000) {
            // 4000活动信息不存在 4001 剩余抽奖次数为0
            localStorage.setItem("isHiddenLottery", true)
          } else {
            this.$toast(e.msg || e.message)
          }
        })
    } else {
      let activitys = JSON.parse(localStorage.getItem("activitys"))
      console.log("activitys == %O", activitys)
      if (activitys && activitys.length > 0) {
        this.showLottery(activitys[activitys.length - 1])
      }
    }
  },
  methods: {
    ...mapActions(["getUserInfo"]),

    loadHomeContentList() {
      getHomeContentList()
        .then((data) => {
          this.serviceInfo.sectionList = data || []
        })
        .catch((e) => {
          Toast(err.msg || e.message)
        })
    },

    onSetingAddress() {
      this.onCloseAddress()
      updateVipAddress().then((data) => { })
      this.$router.push({
        name: "myaddress"
      })
    },
    onCloseAddress() {
      this.showAddress = false
      localStorage.setItem("showAddress", true)
    },
    showLottery(activity) {
      this.lotteryShow = true
      this.activityType = activity.activityType
      this.backgroundImg = activity.popupImg
    },
    enterLottery() {
      this.lotteryShow = false
      let activitys = JSON.parse(localStorage.getItem("activitys"))
      let activityInfo = activitys[activitys.length - 1]
      this.$router.push({
        path: "/lottery",
        query: {
          activityId: activityInfo.id
        }
      })
      activitys.pop()
      localStorage.removeItem("activitys")
      if (activitys.length > 0) {
        localStorage.setItem("activitys", JSON.stringify(activitys))
      }
    },
    onCloseLottery() {
      this.lotteryShow = false
      let activitys = JSON.parse(localStorage.getItem("activitys"))
      activitys.pop()
      localStorage.removeItem("activitys")
      if (activitys.length > 0) {
        localStorage.setItem("activitys", JSON.stringify(activitys))
        this.showLottery(activitys[activitys.length - 1])
      }
    },
    clickRule() {
      this.lotteryShow = false
      let activitys = JSON.parse(localStorage.getItem("activitys"))
      let activityInfo = activitys[activitys.length - 1]
      //activityType 活动类型 1卡卷活动 2奖票活动 3积分活动
      if (activityInfo.activityType == 2 || activityInfo.activityType == 3) {
        let detailImgs = activityInfo.detailImg.split(",")
        this.$router.push({
          name: "ruledetail",
          params: { title: activityInfo.name, detailImgs: detailImgs }
        })
        activitys.pop()
        localStorage.removeItem("activitys")
        if (activitys.length > 0) {
          localStorage.setItem("activitys", JSON.stringify(activitys))
        }
      } else {
        this.$toast("敬请期待！")
      }
    },
    getUserAgent() {
      const ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf("android") != -1) {
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
          //是微信
          console.log("是微信 ")
        } else {
          console.log("android")
        }
      } else if (ua.indexOf("iphone") != -1) {
        console.log("iPhone")
      }
    },
    // 利率
    rateInterval: function (n) {
      if (n.ifStair) {
        let stairRate = n.stairRate
        let minRate = 10000,
          maxRate = 0
        let keys = ["One", "Two", "Three", "Four", "Five", "Six"]
        keys.forEach((k) => {
          if (stairRate["rate" + k]) {
            if (minRate > n.stairRate["rate" + k]) {
              minRate = n.stairRate["rate" + k]
            }
            if (maxRate < n.stairRate["rate" + k]) {
              maxRate = n.stairRate["rate" + k]
            }
          }
        })
        return { minRate: minRate, maxRate: maxRate }
      }
    },
    // 新手专享 判断进度条展示状态
    isSoldOut(n) {
      return n.isFull || n.serverTime >= n.endTime
    },
    novice: function (newbie) {
      if (newbie.isFull || newbie.serverTime >= newbie.endTime) {
        return "已售馨"
      } else {
        if (newbie.sold > 90) {
          return "即将售罄"
        } else if (newbie.sold < 10) {
          return "新开抢中"
        } else {
          return newbie.sold + "%"
        }
      }
    },
    //体验产品
    exclusive: function (item) {
      if (item.isFull || item.serverTime >= item.endTime) {
        return "已售馨"
      } else {
        if (item.sold > 90) {
          return "即将售罄"
        } else if (item.sold < 10) {
          return "新开抢中"
        } else {
          return item.sold + "%"
        }
      }
    },
    // 常规产品 判断进度条展示状态
    progressText: function (item) {
      if (this.isSoldOut(item)) {
        return "100%"
      } else {
        if (item.sold > 90) {
          return "即将售罄"
        } else if (item.sold < 10) {
          return "新开抢中"
        } else {
          return item.sold + "%"
        }
      }
    },
    // 更多
    investClick(index) {
      let token = storage.get("app-token")
      if (!token) {
        this.$router.push("/login")
      } else {
        session.set("invest-nav-index", index - 1)
        this.$router.push("/invest")
      }
    },
    goLicence() {
      this.$router.push("/licence")
    },
    // 我的积分
    moreClick() {
      this.$router.push("/pointsmall")
    },
    // 图片点击跳转
    pointClick(item) {
      let targetUrl = item.targetUrl
      if (targetUrl && targetUrl.length > 1) {
        if (/^((https|http)?:\/\/)[^\s]+/.test(targetUrl)) {
          if (targetUrl.indexOf("lottery") >= 0) {
            if (this.token && this.userInfo.custType > 0) {
              LotteryApi.getActivityinfo(item.activityId)
                .then((data) => {
                  if (data) {
                    let url =
                      location.href.split("#")[0] +
                      "#/lottery?activityId=" +
                      data.id +
                      "&token=" +
                      this.token
                    location.href = url
                  }
                })
                .catch((e) => {
                  this.$toast(e.msg || e.message)
                })
            } else {
              this.$toast("您还不是合格投资者，请联系客服开通！")
            }
          } else {
            this.bannerJumpVue(item)
          }
        } else {
          this.bannerJumpVue(item)
        }
      } else {
        this.bannerJumpVue(item)
      }
    },

    bannerJumpVue(item) {
      let targetUrl = item.targetUrl
      console.log("targetUrl == %O", targetUrl)
      if (
        targetUrl.indexOf("ruledetail") >= 0 ||
        targetUrl.indexOf("luanch") >= 0 ||
        targetUrl.indexOf("discount") >= 0 ||
        targetUrl.indexOf("mayDiscount") >= 0 ||
        targetUrl.indexOf("decDiscount") >= 0
      ) {
        this.$router.push({
          name: "ruledetail",
          params: {
            title: item.title,
            detailImgs: item.imgsDetail,
            targetUrl: targetUrl
          }
        })
      } else if (targetUrl.indexOf("newyearredpack") >= 0) {
        this.$router.push({
          name: "coupon-redenvelopetips",
          params: { title: item.title, detailImgs: item.imgsDetail }
        })
      } else if (targetUrl.indexOf("sevenCelebration") >= 0) {
        localStorage.setItem(
          "ignoreCustKey",
          JSON.stringify({ isBannerJump: true, ignore: 1 })
        )
        this.$router.push({
          name: "anniversarydetials",
          params: { title: item.title, detailImgs: item.imgsDetail }
        })
      } else if (targetUrl.indexOf("sixLotter") >= 0) {
        let url =
          location.href.split("#")[0] + "#/sixLotter?token=" + this.token
        location.href = url
      } else if (targetUrl.indexOf("introduce") >= 0) {
        midautumnLoad()
          .then((data) => {
            if (data) {
              if (data.answer) {
                this.$router.push({ name: "blindbox" })
              } else {
                this.$router.push({ name: "introduce" })
              }
            }
          })
          .catch((e) => {
            console.log("msg == %O", e.msg || e.message)
          })
      } else {
        // this.$router.push(targetUrl)
        location.href = targetUrl
      }
    },

    goNewbie() {
      this.hot_view = true
      this.$router.push("/newbie")
    },

    goLogin() {
      this.$router.push("/login")
    },
    buying(product) {
      this.$router.push({ path: "/detail", query: { productId: product.id } })
    },
    goPromDetail(product) {
      let isProm = this.userInfo.isProm
      if (!isProm) {
        this.showProm()
        return
      }
      // if (this.userInfo.assessNum < 1 || this.userInfo.forceAssess) {
      if (this.userInfo.userLevel < 1) {
        session.setJson("cq", { productId: product.id, target: "home" })
        this.assessShow = true
        return
      }
      //检测绑卡
      if (!this.userInfo.isBindCard) {
        session.setJson("cq", { productId: product.id, target: "home" })
        this.$router.push({ name: "bindcard" })
        return
      }
      storage.setJson("promData", product)
      this.$router.push({ path: "/buyprom" })
    },

    showProm() {
      ProductApi.showProm().then((res) => {
        Dialog.confirm({
          title: "尊敬的用户",
          message: `恭喜您收到${parseInt(
            res.giveAmt / 100
          )}元新手体验金，领取后即可在‘我的优惠券’查看，并可认购‘新手体验金专享资产’获取体验金收益`,
          confirmButtonText: "领取",
          cancelButtonText: "关闭"
        })
          .then(() => {
            // on confirm
            ProductApi.receiveProm({ activityPromId: res.id })
              .then(() => {
                this.setUserInfoIsProm(true)
                storage.setJson("promCoupon", res)
                Toast("领取成功")
              })
              .catch((err) => {
                Toast(err.msg)
              })
          })
          .catch(() => {
            // on cancel
          })
      })
    },
    goAssess() {
      this.$router.push({ path: "/questions" })
    },
    // 咨询客服
    onService() {
      Dialog.confirm({
        title: "提示",
        message: "即将唤起拨号盘"
      }).then(() => {
        Toast(`[天安金交中心] 唤起手机`)
      })
    },
    onNoWhiteListItem(item) {
      if (item.url) {
        if (
          item.url.toLowerCase().indexOf("http://") > -1 ||
          item.url.toLowerCase().indexOf("https://") > -1
        ) {
          location.href = item.url
        } else {
          this.$router.push({ path: item.url })
        }
      }
    },
    onServiceMinItem(item) {
      if (item.path === "/login") {
        if (
          this.userInfo.isAuthName &&
          this.userInfo.isBindCard &&
          this.userInfo.riskMsg.length > 0
        ) {
          this.$router.push({ path: item.path })
        } else {
          Toast("请先完成实名、绑卡和测评！")
        }
      } else if (item.path === "/questions") {
        if (!this.userInfo.isAuthName) {
          //未设置实名
          Dialog.alert({
            title: "温馨提示",
            message: "您还未实名，请先去实名认证？",
            confirmButtonText: "去实名",
            showCancelButton: true,
            theme: "round-button"
          })
            .then(() => {
              this.$router.push({ name: "realname" })
            })
            .catch(() => { })
        } else {
          this.$router.push({ path: item.path })
        }
      } else {
        this.$router.push({ path: item.path })
      }
    },
    onServiceMaxItem(item) {
      if (item.type === "call") {
        this.onCallServiceMobile()
      }
    },
    onCallServiceMobile() {
      location.href = "tel:400-694-0070"
    },
    onConfirm() {
      storage.set("agree-privacy", 1)
      this.dialogPrivacyShow = false
    },
    getNotifyNum() {
      unReadNum()
        .then((data) => {
          this.unReadMsgNum = data || ""
        })
        .catch((e) => {
          console.log(e.msg || e.message)
        })
    },
    // 进入公告列表
    handleNotifyClick() {
      this.$router.push({ name: "notice-list" })
    },
    // 进入公告详情
    handleNotifyItemClick(item) {
      if (item.type == 1) {
        this.$router.push({ name: "coupon" })
      } else {
        this.$router.push({
          name: "notice-detail",
          params: { id: item.id }
        })
      }
    },

    ...mapMutations(["setToken", "setUserInfoIsProm"]),

    loadInvestMsgNoticed() {
      investMsgNoticed()
        .then((data) => { })
        .catch((e) => {
          console.log(e.msg || e.message)
        })
    },
    getPreExperienceProduct() {
      preExperienceProduct()
        .then((data) => {
          this.experienceId = data
        })
        .catch((e) => {
          console.log(e.msg || e.message)
        })
    },
    loadAllNotice() {
      this.allNoticeList = []
      //提示用户生日当天领取积分
      if (this.userInfo.nowIsBirthday && this.userInfo.openMember) {
        let values = { notice: NOTICES.BIRTHDAY, data: {} }
        this.allNoticeList.push(values)
      }
      this.loadInvestMsg()
    },
    loadInvestMsg() {
      investMsg()
        .then((data) => {
          if (data) {
            const values = { notice: NOTICES.INVESTMSG, data: data }
            this.allNoticeList.push(values)
          }
          this.loadAprilRedPacket()
        })
        .catch((e) => {
          console.log(e.msg || e.message)
          this.loadAprilRedPacket()
        })
    },
    loadAprilRedPacket() {
      aprilRedPacket()
        .then((data) => {
          if (data) {
            const values = { notice: NOTICES.APRIREDPACKET, data: data }
            this.allNoticeList.push(values)
          }
          this.loadMayGrantMayRedPacket()
        })
        .catch((e) => {
          console.log(e.msg || e.message)
          this.loadMayGrantMayRedPacket()
        })
    },
    loadMayGrantMayRedPacket() {
      mayGrantMayRedPacket()
        .then((data) => {
          if (data) {
            const values = { notice: NOTICES.MAYREDPACKET, data: data }
            this.allNoticeList.push(values)
          }
          this.loadJunePreNotice()
        })
        .catch((e) => {
          console.log(e.msg || e.message)
          this.loadJunePreNotice()
        })
    },
    loadJunePreNotice() {
      junePreNotice()
        .then((data) => {
          // 恭喜您获得一次加息券抽奖机会，6.18年中大促特惠开启，更多加息券等你来拿。
          if (data) {
            const values = { notice: NOTICES.JUNEPRENOTICE, data: data }
            this.allNoticeList.push(values)
          }
          this.loadActivityNotice()
        })
        .catch((e) => {
          console.log(e.msg || e.message)
          this.loadActivityNotice()
        })
    },
    loadActivityNotice() {
      activityNotice()
        .then((data) => {
          if (data) {
            const values = { notice: NOTICES.ACTIVITYNOTICE, data: data }
            this.allNoticeList.push(values)
          }
          this.loadNovCheck()
        })
        .catch((e) => {
          console.log(e.msg || e.message)
          this.loadNovCheck()
        })
    },
    loadNovCheck() {
      novCheck()
        .then((data) => {
          if (data) {
            const values = { notice: NOTICES.RATECOUPONNOTICE, data: data }
            this.allNoticeList.push(values)
          }
          this.loadUnOperation()
        })
        .catch((e) => {
          console.log("error msg == %O", e.msg)
          this.loadUnOperation()
        })
    },
    loadUnOperation() {
      unOperation()
        .then((data) => {
          if (data == true) {
            const values = { notice: NOTICES.OPERATION, data: data }
            this.allNoticeList.push(values)
          }
          let isHiddenMid = eval(localStorage.getItem("isHiddenMid")) || false
          if (!isHiddenMid) {
            this.loadMidautumn()
          } else {
            this.showFirstNotice()
          }
        })
        .catch((e) => {
          console.log("msg == %O", e.msg || e.message)
          let isHiddenMid = eval(localStorage.getItem("isHiddenMid")) || false
          if (!isHiddenMid) {
            this.loadMidautumn()
          } else {
            this.showFirstNotice()
          }
        })
    },
    loadMidautumn() {
      midautumnLoad()
        .then((data) => {
          if (data) {
            if (!(data.times == 0 && data.answer == true)) {
              const values = { notice: NOTICES.MIDACTIVITY, data: data }
              this.allNoticeList.push(values)
            }
          }
          this.showFirstNotice()
          localStorage.setItem("isHiddenMid", true)
        })
        .catch((e) => {
          this.showFirstNotice()
          localStorage.setItem("isHiddenMid", true)
          console.log("msg == %O", e.msg || e.message)
        })
    },
    loadYuandanRedList() {
      yuandan26RedList()
        .then((data) => {
          if (data && data.length > 0) {
            this.yuandanInfo.list = data
            this.yuandanInfo.showRedpackage = true
          }
        })
        .catch((e) => { })
    },
    onImmediateClaim(ids) {
      this.$toast.loading('加载中...')
      yuandanGrant26(ids)
        .then((data) => {
          this.$toast("领取成功")
          this.yuandanInfo.list = this.yuandanInfo.list.map((item) => {
            if (ids.includes(item.id)) {
              item.hasAward = true
            }
            return item
          })
        })
        .catch((e) => {
          this.$toast(e.msg || e.msg)
        })
    },
    showFirstNotice() {
      if (this.allNoticeList.length > 0) {
        localStorage.setItem(
          "HomeNoticeListKey",
          JSON.stringify(this.allNoticeList)
        )
        this.showNoticeInfo(this.allNoticeList[this.allNoticeList.length - 1])
      }
    },
    loadActivityRead(noticeId) {
      activityRead(noticeId)
        .then((data) => { })
        .catch((e) => {
          console.log(e.msg || e.message)
        })
    },
    loadIsGetGoodsRedPacket() {
      isGetGoodsRedPacket().then((data) => {
        this.couponOverlayParams.showCouponPop = true
        this.couponOverlayParams.params = data
      }).catch((e) => { })
    },
    clickCommitJoin() {
      rewardRedpacket().then((data) => {
        this.couponOverlayParams.showCouponPop = false
        this.$toast(data.msg || '领取成功！')
      }).catch((e) => {
        this.$toast(e.msg || e.message)
      })
    },
    showNoticeInfo(info) {
      if (info.notice == NOTICES.OPERATION) {
        Dialog.confirm({
          title: "温馨提示",
          message: "您有未开奖的红包，请前往‘我的红包列表’开奖",
          confirmButtonText: "前往",
          cancelButtonText: "取消"
        })
          .then(() => {
            this.showNextNotice(false)
            this.$router.push({ name: "coupon-redenvelope" })
          })
          .catch(() => {
            this.showNextNotice(true)
          })
      } else if (info.notice == NOTICES.ACTIVITYNOTICE) {
        this._showTipsInfo(
          "温馨提示",
          info.data.contents || "",
          "关闭",
          "前往查看",
          () => {
            this.showNextNotice(false)
            this.loadActivityRead(info.data.id)
            this.$router.push({ name: "coupon" })
          },
          () => {
            this.loadActivityRead(info.data.id)
            this.showNextNotice(true)
          }
        )
      } else if (info.notice == NOTICES.JUNEPRENOTICE) {
        /*
        this._showTipsInfo(
          "温馨提示",
          "恭喜您获得一次加息券抽奖机会，6.18年中大促特惠开启，更多加息券等你来拿。",
          "关闭",
          "查看活动详情",
          () => {
            this.showNextNotice(false)
            this.$router.push({ name: "sixLotter" })
          },
          () => {
            this.showNextNotice(true)
          }
        )*/
        this.showSpecialActivity = true
      } else if (info.notice == NOTICES.MAYREDPACKET) {
        // // 23五月满减券活动登录首次提示
        this._showTipsInfo(
          "",
          "劳动最光荣，奋斗最幸福。祝您五一劳动节快乐！赠送您3张劳动月满减券可于本月投资时使用，天安金交中心向所有劳动者致敬！",
          "关闭",
          "前往查看",
          () => {
            this.showNextNotice(false)
            this.getUserInfo()
            this.$router.push({ name: "coupon" })
          },
          () => {
            this.showNextNotice(true)
            this.getUserInfo()
          }
        )
      } else if (info.notice == NOTICES.APRIREDPACKET) {
        this._showTipsInfo(
          "温馨提示",
          "恭喜您获得抽奖机会，春暖花开踏青活动特惠开启，更多加息券等你来拿。",
          "关闭",
          "去参与",
          () => {
            this.showNextNotice(false)
            this.getUserInfo()
            loadAprilOuting().then((data) => {
              if (data) {
                // let detailImgs = data.detailImg.split(",")
                // this.$router.push({
                //   name: "ruledetail",
                //   params: { title: data.name, detailImgs: detailImgs }
                // })
                this.$router.push({ name: "aprilLotter" })
              }
            })
          },
          () => {
            this.showNextNotice(true)
            this.getUserInfo()
          }
        )
      } else if (info.notice == NOTICES.INVESTMSG) {
        Dialog.alert({
          title: "温馨提示",
          messageAlign: "left",
          message: info.data.contents,
          confirmButtonText: "我知道了"
          // theme: "round-button"
        }).then(() => {
          this.showNextNotice(true)
          this.loadInvestMsgNoticed()
        })
      } else if (info.notice == NOTICES.BIRTHDAY) {
        Dialog.alert({
          title: "温馨提示",
          message: "您好！今天是您的生日哟，是否领取您的生日积分奖励？",
          confirmButtonText: "确认领取",
          showCancelButton: true,
          theme: "round-button"
        })
          .then(() => {
            MemberIntegralApi.birthdaySendScore()
              .then((data) => {
                if (data) {
                  this.$toast("领取成功，可以去积分明细查看喔～")
                  this.userInfo.nowIsBirthday = false
                }
                this.showNextNotice(true)
              })
              .catch((e) => {
                this.$toast(e.msg || e.message)
              })
          })
          .catch(() => {
            this.showNextNotice(true)
          })
      } else if (info.notice == NOTICES.MIDACTIVITY) {
        this.showAnswerPop = true
        this.answer = info.data.answer || false
      } else if (info.notice == NOTICES.RATECOUPONNOTICE) {
        this.showRateCouponPop = true
        this.rateCouponParams.id = info.data
      }
    },
    showNextNotice(isShowNext) {
      let catchList = JSON.parse(localStorage.getItem("HomeNoticeListKey"))
      catchList.pop()
      localStorage.removeItem("HomeNoticeListKey")
      if (catchList.length > 0) {
        localStorage.setItem("HomeNoticeListKey", JSON.stringify(catchList))
        if (isShowNext) {
          this.showNoticeInfo(catchList[catchList.length - 1])
        }
      }
    },
    onJoinSpecialActivity(join) {
      this.showSpecialActivity = false
      if (join) {
        this.showNextNotice(false)
        this.$router.push({ name: "sixLotter" })
      } else {
        this.showNextNotice(true)
      }
    },
    onCloseAnswerPop() {
      this.showAnswerPop = false
      this.showNextNotice(true)
    },
    onJoinAnswer() {
      this.showNextNotice(false)
      if (this.answer) {
        this.$router.push({ name: "blindbox" })
      } else {
        this.$router.push({ name: "introduce" })
      }
    },
    onCloseRateCouponPop() {
      this.showRateCouponPop = false
      this.showNextNotice(true)
    },
    onGetRateCoupon() {
      novReward(this.rateCouponParams.id)
        .then((data) => {
          this.$toast("领取成功！")
          this.showNextNotice(true)
        })
        .catch((e) => {
          this.showNextNotice(true)
          this.$toast(e.msg)
        })
    }
  },
  computed: {
    ...mapGetters(["channel", "os", "token", "userInfo"])
  }
}
</script>

<style lang="less" scoped>
@import "./idx.less";

//轮播图
.home-swipe {
  height: 150px;

  .banner-image {
    width: 100%;
    height: 100%;
  }
}

.notify {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 10;
}

// 改版后2020.7.24
.notify-container {
  display: flex;
  width: 100%;
  // height: 40px;
  align-items: center;
  vertical-align: middle;
  background-color: #fff;

  .notify-img {
    margin-left: 15px;
    display: inline-block;
    height: 20px;
    width: 20px;
  }
}

.notify-swipe {
  height: 25px;
  margin-left: 10px;
  width: calc(100% - 10px);

  .notify-title {
    line-height: 25px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
  }
}

::v-deep .van-tag--large {
  font-size: 11px;
}

// 产品推荐
.recommended {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 13px 5px 13px;
  font-size: 16px;
  font-weight: 700;
  color: #333333;

  // span:nth-child(1) {
  //   font-size: 16px;
  //   font-weight: 700;
  //   color: #333333;
  // }
  // span:nth-child(2) {
  //   font-size: 13px;
  //   color: #333333;
  //   width: 50px;
  //   text-align: right;
  // }
  // 查看更多
  .seeMore {
    font-size: 15px;
    color: #333;
    text-align: right;
    letter-spacing: 1px;

    .van-icon-arrow {
      vertical-align: middle;
    }
  }
}

// 常规产品 新人专享
.common {
  margin: 0 13px;
  margin-bottom: 10px;
  background-color: #fff;
  border-radius: 5px;
  position: relative;

  .product-information {
    padding: 14px 12px;

    &.sold-out {
      filter: grayscale(0%) opacity(0.6);
    }

    // name
    .title {
      font-size: 16px;
      height: 1.5em;
      overflow: hidden;
      color: #333333;
      word-break: break-all;

      .points {
        margin-left: 5px;
        color: #ffffff;
        border-radius: 3px;
        background-color: #fc6524;
      }
    }

    // tag
    .tag {
      .van-hairline--surround::after {
        border: none;
      }

      .van-tag {
        font-size: 12px;
      }

      .hide {
        display: none;
      }

      div {
        display: inline-block;
        height: 8px;
        width: 0.8px;
        background-color: #ff9900;
      }
    }

    // data
    .data {
      display: flex;
      align-items: center;

      // text
      .txt {
        color: #999;
        font-size: 14px;
      }

      // gain
      .gain {
        flex: 1;

        b {
          font-size: 36px;
          color: #fc6524;
          font-weight: normal;
        }

        span {
          font-size: 15px;
          color: #fc6524;
          margin-left: 1px;
        }

        .fuhao {
          font-size: 18px;
          color: #fc6524;
          margin: auto 5px;
        }
      }

      // term
      .term {
        flex: 1;
        text-align: center;

        .term-box {
          height: 72px;
          padding-right: 40px;

          // day
          .day {
            height: 53px;
            line-height: 53px;
            color: #666;

            .s1 {
              font-size: 22px;
            }

            .s2 {
              font-size: 18px;
              margin-left: 2px;
            }
          }
        }
      }
    }
  }

  // progress
  .progress {
    margin-top: 10px;

    .progress-box {
      display: flex;
      align-items: center;

      // title
      .title {
        font-size: 11px;
        color: #666;
        margin-top: 3px;
      }

      // progress-style
      .progress-style {
        width: 250px;
        height: 7px;
        line-height: 16px;
        position: relative;
        background-color: #e9e9e9;
        border-radius: 7px;
        overflow: hidden;

        .progress-pivot {
          box-sizing: border-box;
          height: 100%;
          background-color: #fc6524;
          border-radius: 7px;
        }
      }

      // result
      .result {
        font-size: 14px;
        margin-left: 10px;
        color: #666;
      }
    }
  }

  .aside,
  .signet-sold-out {
    position: absolute;
    top: 16px;
    right: 0px;
    padding: 0 12px;
    line-height: 24px;
    text-align: center;
    font-size: 13px;
    box-sizing: border-box;
    border-radius: 25px 0 0 25px;
    color: #fff;
  }

  .signet-sold-out {
    background-color: #d6d6d7;
  }

  // aside
  .aside {
    background-color: rgb(252, 101, 36);
  }
}

// 图片展示
.img {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 13px;

  img {
    width: 80px;
    height: 55px;
    border-radius: 6px;
  }
}

// 间距
.line {
  height: 10px;
}

// -------------------------------------------------------------------------------------------------------------------
// 积分商城
.points-city {
  font-size: 16px;
  font-weight: 700;
  margin-left: 20px;
  margin-top: 20px;
}

.jrong-box {
  margin: 12px 13px;
  border-radius: 8px;
  background-color: #ffffff;
}

.jrong {
  .jrong-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 27px 25px;

    .jrong-list-item {
      width: 130px;
      margin-bottom: 28px;

      img {
        width: 130px;
        height: 130px;
        // width: 40vw;
        // height: 40vw;
      }

      .text {
        b {
          height: 35px;
          font-size: 12px;
          font-weight: 700;
          color: #333333;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }

      .price {
        color: #7b7a7a;
        font-size: 10px;
        margin-top: 10px;
        margin-bottom: 10px;
        font-weight: 700;
        text-decoration: line-through;
      }

      button {
        height: 26px;
        width: 130px;
        font-size: 12px;
        border-radius: 2px;
        border: none;
      }
    }
  }
}

.fan-points {
  height: 12px;
  background-color: #fc6524;
  padding: 2px 6px;
  margin-left: 10px;
  font-size: 12px;
  color: #ffffff;
  border-radius: 3px;
  // position: relative;
}

.points-to-benefits {
  margin: 14px 13px;

  .box {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      display: flex;
      align-items: center;

      .sp1 {
        font-size: 16px;
        font-weight: 700;
      }

      .sp2 {
        font-size: 10px;
        color: #ff3030;
        margin-left: 5px;
        margin-top: 2px;
      }
    }

    .sp3 {
      text-align: right;
      color: #333;
      font-size: 13px;
    }
  }
}

.service-bg {
  .recommended {
    padding: 10px 13px;
  }

  .item-bg {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 13px;

    .item {
      // width: 80px;
      width: 107px;
      height: 100px;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .col0 {
      background-color: rgb(254, 252, 249);
    }

    .col1 {
      background-color: rgb(249, 250, 255);
    }

    .col2 {
      background-color: rgb(250, 247, 253);
    }

    .col3 {
      background-color: rgb(249, 250, 255);
    }

    img {
      width: 30px;
      height: 25px;
    }

    .item-btn {
      border-radius: 15px;
      border: solid 1px rgb(248, 212, 192);
      color: rgb(237, 111, 58);
      font-size: 11px;
      font-weight: 500;
      margin-top: 10px;
      padding: 0 10px;
      text-align: center;
      height: 20px;
      line-height: 20px;
      padding-top: 1px;
    }
  }

  .max-item-bg {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 13px;
    margin-top: 15px;

    .max-item {
      width: 166.5px;
      height: 80px;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: rgb(132, 131, 131);
      font-size: 12px;
    }

    .max-col0 {
      background-color: rgb(252, 244, 245);
    }

    .max-col1 {
      background-color: rgb(254, 252, 249);
    }
  }
}

.service-bottom-bg {
  padding-bottom: 60px;

  .service-section-bg {
    .recommended {
      padding: 10px 13px;
    }

    .section-item-bg {
      display: flex;
      align-items: center;
      margin: 0 13px;
      background-color: white;
      border-radius: 6px;
      height: 90px;

      .left-img {
        margin-left: 20px;
        width: 65px;
        height: 52px;
      }

      .right-bg {
        width: calc(100% - 115px);
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-left: 15px;

        .r-title {
          font-weight: 500;
        }

        .r-content {
          margin-top: 5px;
          color: rgb(132, 131, 131);
          font-size: 12px;
        }
      }
    }
  }
}

.new-popup {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);

  .popup-main {
    overflow: hidden;
    background-color: transparent;
    width: 341px;

    .popup-main-body {
      min-height: 408px;
      background: url(../../assets/img/news/coupon_bg.jpg);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      .center-text {
        margin-top: 47%;
        color: red;
        font-weight: 700;
        width: 100%;
      }

      .sub-text {
        color: red;
      }

      .info-bg {
        margin-top: 20px;
        width: 250px;
        min-height: 108px;
        background: url(../../assets/img/news/coupon_content.jpg);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;

        .info-left {
          .amount {
            font-size: 50px;
            font-weight: 800;
          }
        }

        .info-right {
          text-align: left;
        }
      }
    }

    .btn-join {
      margin-top: 10px;
      margin-left: calc(50% - 125px);
      width: 250px;
      height: 48px;
      background: url(../../assets/img/news/coupon_btn.jpg);
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
}
</style>
